import { useState } from "react";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../../backend/firebase";
import { FaGoogle, FaDatabase, FaLayerGroup, FaCode } from "react-icons/fa";
import "./Login.css";
import { ClipLoader } from "react-spinners";

const COLORS = {
  primary: "#0066FF",
  secondary: "#00D4AA",
  accent: "#FF6B35",
  background: "#09090B",
  surface: "#18181B",
  surfaceHighlight: "#27272A",
  text: "#FAFAFA",
  textSecondary: "#A1A1AA",
  border: "#3F3F46",
};

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);

  const googleSignIn = async () => {
    setIsLoading(true);
    try {
      await signInWithPopup(auth, provider);
    } catch (err) {
      alert(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="login-wrapper"
      style={{
        "--primary": COLORS.primary,
        "--secondary": COLORS.secondary,
        "--bg": COLORS.background,
        "--surface": COLORS.surface,
        "--surface-light": COLORS.surfaceHighlight,
        "--text": COLORS.text,
        "--text-dim": COLORS.textSecondary,
        "--border": COLORS.border,
      }}
    >
      {/* LEFT SIDE: Visuals & Marketing */}
      <div className="login-marketing-side">
        {/* Background Mesh */}
        <div className="mesh-background">
          <div className="mesh-blob blob-1"></div>
          <div className="mesh-blob blob-2"></div>
        </div>

        <div className="marketing-content">
          <div className="logo-badge">
            <span className="logo-dot"></span> SETA v1.0
          </div>

          <h1 className="marketing-title">
            The standard for <br />
            <span className="text-gradient">open datasets.</span>
          </h1>

          <p className="marketing-subtitle">
            Host, version, and collaborate on data with a platform built for the
            AI era.
          </p>

          <div className="feature-badges">
            <div className="f-badge">
              <FaDatabase /> Versioning
            </div>
            <div className="f-badge">
              <FaLayerGroup /> Collaboration
            </div>
            <div className="f-badge">
              <FaCode /> API First
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE: Login Form */}
      <div className="login-form-side">
        <div className="form-container">
          <div className="form-header">
            <h2>Welcome back</h2>
            <p>Sign in to your account to continue</p>
          </div>

          <button
            className={`login-button ${isLoading ? "loading" : ""}`}
            onClick={googleSignIn}
            disabled={isLoading}
          >
            <div className="button-content">
              {isLoading ? (
                <ClipLoader color="black" size={12} />
              ) : (
                <>
                  <span>Continue with Google</span>
                </>
              )}
            </div>
          </button>

          <div className="login-footer">
            <p>
              By clicking continue, you agree to our{" "}
              <a href="#">Terms of Service</a> and{" "}
              <a href="#">Privacy Policy</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
